<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on: tooltip, attrs }">
      <span v-on="{ ...tooltip }" v-bind="{ ...attrs }">
        <v-btn
          v-bind="{ ...$attrs }"
          v-on="{ ...$listeners }"
          :disabled="masterInstancesNumberMaxReached"
          :icon="!hasSlotDefault()"
          class="mx-1"
          @click.stop="instanceCreate"
        >
          <v-icon v-if="iconAlternative" :left="hasSlotDefault()">
            mdi-format-list-checks
          </v-icon>
          <v-icon v-else :left="hasSlotDefault()">
            mdi-plus
          </v-icon>
          <slot v-if="hasSlotDefault()" name="default"></slot>
        </v-btn>
      </span>
    </template>
    <span v-if="masterInstancesNumberMaxReached">
      Sorry, you have reached the maximum number ({{
        userLogged.usageLimits.masterInstancesNumberMax
      }}) of checklists per model allowed by your current plan; contact us to extend this limit
    </span>
    <span v-else> Create a new checklist </span>
  </v-tooltip>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Logger from '@/lib/Logger'

import ClInstance from '@/models/ClInstance'

export default {
  props: {
    master: {
      type: Object,
      required: true,
    },
    iconAlternative: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data: () => ({
    //
  }),

  computed: {
    masterInstancesNumberMaxReached() {
      return !this.master.actionsAllowed?.instanceCreate
    },
    //
    ...mapState({
      userLogged: state => state.userLogged,
    }),
  },

  methods: {
    async instanceCreate() {
      Logger.debug('instanceCreate:', this.master)
      const instanceNew = {
        title: 'New checklist ' + Date.now(), //NB: ho usato spazi speciali no-break
        clMasterId: this.master.id,
      }
      try {
        const instanceNewRes = await ClInstance.create(instanceNew)
        Logger.debug('Creazione effettuata:', instanceNewRes.id)
        // this.$router.push({ name: 'Instance', params: { instanceId: instanceNewId } })
        this.$router.push({ path: '/checklist/' + instanceNewRes.id })
      } catch (e) {
        Logger.error(e)
        this.toastSet({
          message: 'Error in creating a new checklist',
          color: 'error',
        })
      }
    },
    hasSlotDefault() {
      return !!this.$slots['default'] || !!this.$scopedSlots['default']
    },
    ...mapMutations(['toastSet']),
  },
}
</script>
